import { module } from 'modujs'

const CLASS = {
    IS_SUCCESS: 'is-success',
    IS_LOADING: 'is-loading',
    IS_ERROR: 'is-error'
}

export default class extends module {
    constructor(m) {
        super(m)

        this.isRecaptchaEnabled = false
        this.events = {
            submit: 'submit',
            click: {
                input: 'enableRecaptcha'
            }
        }
    }

    enableRecaptcha() {
        if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
            if (this.isRecaptchaEnabled) {
                return
            }

            this.isRecaptchaEnabled = true

            const elem = this.$('recaptcha')[0]
            if (elem && !elem.getAttribute('data-grecaptcha-id')) {
                const widgetId = grecaptcha.render(elem, {
                    sitekey: elem.getAttribute('data-sitekey')
                })
                elem.setAttribute('data-grecaptcha-id', widgetId)
            }
        }
    }

    resetRecaptcha() {
        if (this.recaptchaId !== null) {
            window.grecaptcha.reset()
        }
    }

    init() {
        this.confirmMessage = this.getData('confirm-message')
        this.errorMessage = this.getData('error-message')
    }

    /**
     * Set loading state (show loader, fade form, and other UI)
     *
     * @param {none}
     */
    setLoadingState() {
        this.el.classList.add(CLASS.IS_LOADING)
    }

    /**
     * Set confirmation state
     * Display confirmation message
     *
     * @param {string} | confirmation message
     */
    setConfirmationState(message) {
        this.clearState()

        this.el.reset()

        this.el.classList.add(CLASS.IS_SUCCESS)
        this.$('feedback')[0].innerHTML = message

        this.updateScroll()
    }

    /**
     * Set error state
     *
     * @param {message} | form error message
     */
    setErrorState(message) {
        this.clearState()

        this.el.classList.add(CLASS.IS_ERROR)
        this.$('feedback')[0].innerHTML = message

        this.updateScroll()
    }

    /**
     * Clear all state
     *
     * @param
     */
    clearState() {
        this.el.classList.remove(CLASS.IS_SUCCESS, CLASS.IS_LOADING, CLASS.IS_ERROR)

        this.$('feedback')[0].innerHTML = ""

        this.updateScroll()
    }

    /**
     * In case of use of locomotive-scroll, we need to update page height
     *
     * @param {none}
     */
    updateScroll() {
        requestAnimationFrame(() => { this.call('update', null, 'Scroll') })
    }

    /**
     * Custom submit
     *
     * @param {event} | event
     */
    submit(event) {
        try {
            event.preventDefault()

            this.clearState()
            this.setLoadingState()

            const form = event.target
            const formData = new FormData(form)
            let isError = false

            let data = {}
            for (let [key, prop] of formData) {
                data[key] = prop
            }

            fetch(form.getAttribute('action'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            }).then(response => {
                if (response.status !== 200) {
                    isError = true
                }
                return response.json()
            })
            .then(response => {
                if (isError) {
                    this.setErrorState(this.errorMessage)
                } else {
                    this.setConfirmationState(this.confirmMessage)
                }
                this.resetRecaptcha()
            })
            // .catch(() => {
            // })
            .finally(() => {
                this.el.classList.remove(CLASS.IS_LOADING)
            })
        } catch (error) {
            console.error(error)
        }
    }
}
